const riskPageData = {
    header: {
        image: {
            name: "risk.jpg",
            alt: "",
        },
    },
    mainTitle: "Risk Management",
    paragraphOne: "SAB’s risk management framework is guided by regulatory frameworks as established by SAMA and international best practices. Our approach to risk management is underpinned by our culture and values, clarifying responsibility as well as enabling effective coordination of risk and control activities. We have adopted the 3 lines of defence (LOD) framework which is summarised below:",
    listOne: [
        "The first line of defence owns the risks and is responsible for identifying, recording, reporting and managing them in line with risk appetite, and ensuring that the right controls and assessments are in place to mitigate them.",
        "The second line of defence challenges the first line of defence on effective risk management, and provides advice, guidance and assurance of the first line of defence to ensure it is managing risk effectively.",
        "The third line of defence is internal audit function, which provides independent assurance as to whether our risk management approach and processes are designed and operating effectively"
    ],
    // paragraphThree : "",
    // paragraphFour : "",
    borderLeftBox: {
        title: "How We Manage ESG Risks",
    },
    paragaphSix: "SAB manages ESG risk within the risk management framework via policies and controls. We employ several essential risk management tools. These include: ",
    list: [
        "a risk appetite statement",
        "a top- and emerging risks and a risk map that encompasses financial and non-financial risks",
        "Stress testing"
    ],
    paragraphFive: "Via regular stress testing, we assess our capital and liquidity requirements in response to external shocks. For further information on these tools and how they are utilised, please consult this year’s annual report.",
    paragraphSeven: "The central principles governing climate risk management are seamlessly integrated within SAB’s existing Risk Management framework and 3 LOD model. Our risk management process at SAB follows a structured five-step approach, encompassing identification, assessment, management, and reporting of risks, with clearly defined roles and responsibilities.",
    paragraphEight: "In the following, our five-step approach is outlined:",
    listTwo: [
        "Define & Enable",
        "Identify & Assess",
        "Manage",
        "Aggregate & Report",
        "Govern"
    ]
};

export default riskPageData;